import React from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../components/common/Button";
import { getWeekendInfoByName } from "../../backend/weekends/weekendInfo";
import { sanitizeHTML } from "../../utils/htmlSanitizer";

const LandingVideo = ({ weekendId }: { weekendId: number }) => {
    const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

    return (
        <div style={styles.cardWrapper}>
            {/* Full-cover background image */}
            <img
                src={getWeekendInfoByName(weekendId, "videoPhotoLink")}
                style={styles.backgroundImage}
                onError={(e) => (e.currentTarget.src = "/assets/landing/nrk.png")}
                alt="відео"
            />

            {/* Dark overlay so text stays readable */}
            <div style={styles.overlay} />

            {/* Bottom bar: heading + button in one row */}
            <div
                style={{
                    ...styles.bottomBar,
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: isMobile ? "flex-start" : "center",
                    gap: isMobile ? "1rem" : "4rem",
                    padding: isMobile ? "1.5rem var(--main-container-margin, 1.5rem)" : "2rem var(--main-container-margin, 3rem)",
                }}
            >
                <p
                    style={{
                        ...styles.mainHeading,
                        fontSize: isMobile ? "9vw" : "clamp(2rem, 4vw, 3.5rem)",
                        margin: 0,
                        overflowWrap: "break-word",
                        order:isMobile?0:1,
                    }}
                    dangerouslySetInnerHTML={{
                        __html: sanitizeHTML(getWeekendInfoByName(weekendId, "videoHeader")),
                    }}
                />

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <Button
                        text={"ПЕРЕГЛЯНУТИ"}
                        external_link={getWeekendInfoByName(weekendId, "videoLink")}
                        textColor="var(--black)"
                        hoverTextColor="var(--orange)"
                        border="3px solid var(--black)"
                        hoverBorder="3px solid var(--black)"
                        backgroundColor="var(--orange)"
                        hoverBackgroundColor="var(--black)"
                        fontSize={isMobile ? "9vw" : "3rem"}
                        padding={isMobile ? "1rem 0rem" : "1rem 2rem"}
                        fontWeight="bold"
                        containerProps={isMobile ? { width: "var(--main-container-width)" } : {}}
                        isSimple={true}
                    />
                </div>
            </div>
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    cardWrapper: {
        position: "relative",
        width: "100%",
        minHeight: "600px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
    },
    backgroundImage: {
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    overlay: {
        position: "absolute",
        inset: 0,
        background: "linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.15) 60%, transparent 100%)",
        pointerEvents: "none",
    },
    bottomBar: {
        position: "relative", 
        zIndex: 1,
        display: "flex",
        width: "100%",
        boxSizing: "border-box",
    },
    mainHeading: {
        color: "#ffffff",
        fontWeight: "bold",
        flex: 1,
    },
};

export default LandingVideo;